import { RequestMethods } from 'utils/axios/methods'
import { call, put } from 'redux-saga/effects'
import { Actions_PageLoader } from 'redux/modules/pageloader/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { TStoreTemplate } from 'redux/config/root-types'
import { TParentOrganization } from 'redux/modules/parentOrganizations/TReducer'
import { Actions_ParentOrganizations } from 'redux/modules/parentOrganizations/Actions'

const { get } = RequestMethods()

export default function* SagaPage_ParentOrganizations() {
  try {
    yield put(Actions_PageLoader.store.showLoader())
    //------------------------- Getting and saving parent organizations ----------------------//

    const parentOrganizations: TStoreTemplate<TParentOrganization[]> = yield call(
      async () => await get<TParentOrganization[]>('/organizations/parents', { hideInactive: false }),
    )

    yield put(Actions_ParentOrganizations.store.saveParentOrganizations(parentOrganizations))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_PageLoader.store.hideLoader())
  }
}
